import { FC, RefObject, useEffect, useState } from 'react';
import { sceneStore, charactersStore } from 'stores';
import { ICharacterCsv } from 'shared/interfaces';

interface DatePickerProps {
  ref?: RefObject<HTMLDivElement>;
  setCurrentData: React.Dispatch<React.SetStateAction<string>>;
}

export const DatePicker: FC<DatePickerProps> = ({ setCurrentData }) => {
  const [dates, setDates] = useState<ICharacterCsv[] | null>(null);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);

  // 🔹 Загружаем CSV-файлы выбранного персонажа
  useEffect(() => {
    if (charactersStore.selectedCharacter?.csvFiles) {
      setDates(charactersStore.selectedCharacter.csvFiles);
    } else {
      setDates([]);
    }
  }, [charactersStore.selectedCharacter]);

  const onSelectDate = (date: string) => {
    setSelectedDate(date);
    charactersStore.selectCsvDate(date); // обновляем данные CSV в store
    setCurrentData(date);
  };

  const onSelectAttempt = (attemptIndex: number) => {
    if (!selectedDate) return;
    //sceneStore.currentAttempt = attemptIndex + 1; // индекс попытки
    setCurrentData(`${selectedDate} Попытка ${attemptIndex + 1}`);
  };

  return (
      <>
        <div className="characterInfo-req-menu__dates">
          <span className="characterInfo-req-menu__dates-title">Дата CSV:</span>
          {dates?.map((csv) => (
              <div
                  className="dateItem"
                  key={csv.csvDate}
                  onClick={() => onSelectDate(csv.csvDate)}
              >
                {csv.csvDate}
              </div>
          ))}
          {dates?.length === 0 && <div>Нет доступных дат для персонажа</div>}
        </div>

        <span className="line"></span>

        <div className="characterInfo-req-menu__attempts">
          <span className="characterInfo-req-menu__dates-title">Попытки:</span>
          {dates
              ?.find((csv) => csv.csvDate === selectedDate)
              ?.csvData.map((_, index) => (
                  <div
                      className="dateItem"
                      key={index}
                      onClick={() => onSelectAttempt(index)}
                  >
                    Попытка {index + 1}
                  </div>
              ))}
          {selectedDate && dates?.find((csv) => csv.csvDate === selectedDate)?.csvData.length === 0 && (
              <div style={{ width: '100%' }}>Нет попыток за эту дату</div>
          )}
        </div>
      </>
  );
};

// Хук для клика вне элемента
function useClickOutside(ref: RefObject<HTMLDivElement>, callback: () => void): void {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [ref, callback]);
}

export default useClickOutside;
